import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TipRateModal from './TipRateModal';
import { addTipsToWorkersAction, getJobDetails, rateWorkersAction } from '../../../../actions/jobs';
import { UIShowConfirm } from '../../../../actions/ui';
import { shouldRateWorkers } from '../../../../helpers/jobs';
import { confirmationMessages } from '../../../../constants/text';

class TipsAndRates extends Component {
  static propTypes = {
    job_id: PropTypes.number.isRequired,
    hiredWorkers: PropTypes.array,
    canAddTips: PropTypes.bool.isRequired,
    canRateWorkers: PropTypes.bool.isRequired,
    addTipsToWorkersAction: PropTypes.func.isRequired,
    rateWorkersAction: PropTypes.func.isRequired,
    getJobDetails: PropTypes.func.isRequired,
    showRateModal: PropTypes.bool
  };

  state = {
    signatureModalIsOpen: false,
    tipRateModalIsOpen: false,
    isTipModal: false,
    isRateModal: false
  };

  openTipModal = () => this.props.UIShowConfirm(confirmationMessages.taxOnTips,
    () => {
      this.setState({ isTipModal: true });
      this.openTipRateModal();
    }
  );

  openRateModal = () => {
    this.openTipRateModal();
    this.setState({
      isRateModal: true
    });
  };

  openTipRateModal = () => {
    this.setState({
      tipRateModalIsOpen: true
    });
  };

  closeTipRateModal = () => {
    this.setState({
      tipRateModalIsOpen: false,
      isTipModal: false,
      isRateModal: false
    });
  };

  /**
   * @param {object} formData
   * @param {number} formData.tip_amount
   * @param {number[]} formData.workers
   * @return {AxiosPromise<any>}
   */

  submitAddingTips = formData => {
    return this.submitForm(formData, this.props.addTipsToWorkersAction);
  };

  submitRatingWorkers = formData => {
    return this.submitForm(formData, this.props.rateWorkersAction);
  };

  submitForm = (formData, action) => {
    const { job_id, getJobDetails } = this.props;
    return action(job_id, formData).then(() => {
      return getJobDetails(job_id).then(() => this.closeTipRateModal());
    })
      .then(() => {
        if (shouldRateWorkers(this.props.hiredWorkers)) {
          this.openRateModal();
        }
      });
  };

  _getWorkersForRating = () => {
    const { hiredWorkers } = this.props;
    if (hiredWorkers) {
      return hiredWorkers.filter(worker => {
        return !worker.job_satisfaction_rating;
      });
    } else {
      return [];
    }
  };

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (!prevProps.showRateModal && this.props.showRateModal) {
      this.openRateModal();
    }
  }

  render () {
    const { tipRateModalIsOpen, isTipModal, isRateModal } = this.state;
    const { hiredWorkers, canAddTips, canRateWorkers } = this.props;
    const workersForRating = this._getWorkersForRating();
    const modalWorkersList = isTipModal ? hiredWorkers : isRateModal ? this._getWorkersForRating() : [];

    return (
      <React.Fragment>
        { canAddTips && (
          <button
            className='button button-primary button-worker-action'
            onClick={this.openTipModal}
          >
            Add Tip
          </button>
        )}
        { canRateWorkers && workersForRating.length > 0 && (
          <button
            className='button button-primary button-worker-action'
            onClick={this.openRateModal}
          >
            Rate Workers
          </button>
        )}
        <TipRateModal
          isOpen={tipRateModalIsOpen}
          closeModal={this.closeTipRateModal}
          workersList={modalWorkersList}
          submitAddingTips={this.submitAddingTips}
          submitRatingWorkers={this.submitRatingWorkers}
          isTipModal={isTipModal}
          isRateModal={isRateModal}
        />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  getJobDetails,
  addTipsToWorkersAction,
  rateWorkersAction,
  UIShowConfirm
};

export default connect(null, mapDispatchToProps)(TipsAndRates);



// WEBPACK FOOTER //
// ./src/components/app/jobDetails/TipsAndRates/index.js